module.exports = __webpack_public_path__ + "img/govIcon.14d9e860.png";